import { PlanScheduleDay } from "./plan-schedule-day";
import { DateTime } from "luxon";

export class AttachScheduler {
  planId!: string;
  planWeekDays!: number[];
  fromDate!: DateTime;
  toDate!: DateTime;
  bufferHours!:number;
  timeZone!:string;
  offSet!:number;
  executionTime!:string;
}
